import React from 'react'

function ReportEnquiryHeader() {
  return (
    <div className="flex flex-col gap-1 w-full p-8 pb-4">
      <h1 className="text-3xl font-semibold text-[#181d27]">
        Report enquiry
      </h1>
      <p className="text-[16px] text-[#535862]">
        Manage and monitor employee credit enquiry requests.
      </p>
    </div>
  )
}

export default ReportEnquiryHeader
